import { render, staticRenderFns } from "./invoice-exchange-form.vue?vue&type=template&id=5dd7f826"
import script from "./invoice-exchange-form.vue?vue&type=script&lang=js"
export * from "./invoice-exchange-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports